<template>
    <div class="up-box flex align-start">
        <el-upload
            :class="{disabled:disabled}"
            :action="FILE_UPLOAD_HOST"
            :data="fileData"
             name="file"
            :accept="accept"
            :show-file-list="false"
            :on-error="uploadError"
            :on-success="uploadSuccess"
            :before-upload="beforeAvatarUpload" :disabled="disabled">
           <div class="flex flex-direction" v-if="!disabled">
               <el-button  class="btn small" type="primary">上传附件</el-button>
               <div class="self-start">文件不超过10M</div>
           </div>
        </el-upload>
        <div class="flex flex-direction margin-left-sm" v-if="files">
            <div class="flex flex-direction"  v-if="multiple">
                <div class="file flex align-center justify-between" style="min-width: 200px" v-for="(item,index) in files" :key="index">
                    <a class="name" :href="BASE_URL + item.url" target="_blank">{{item.name}}</a>
                    <el-button class="margin-left-sm"  type="text"  @click="delItem(index)" v-if="!disabled"><i class="el-icon-delete"></i></el-button>
                </div>
            </div>
            <a class="ovHide text-left" :href="BASE_URL + files.url" target="_blank" v-else >{{files.name}}</a>
        </div>
    </div>
</template>

<script>
import {BASE_URL, FILE_UPLOAD_HOST} from "@/config";
import {confirm, TOAST, toast} from "@/utils/utils";

    export default {
        name: "UploadFile",
        data() {
            return {
                BASE_URL:BASE_URL,
                FILE_UPLOAD_HOST: FILE_UPLOAD_HOST,
            }
        },
        props: {
            type: {
                type: String,
                default: ''
            },
            files: {
                type: Object
            },
            disabled: {
                type: Boolean,
                default: false
            },
            multiple: {
                type: Boolean,
                default: false
            },
            accept:{
                type: String,
                default: '*'
            }
        },
        computed: {
            token() {
                return this.$store.state.user.token;
            },
            fileData() {
                return {
                    token: this.token,
                }
            }
        },
        created() {

        },
        methods: {
            //  上传钱判断
            beforeAvatarUpload(file) {
                const isLt2M = file.size / 1024 / 1024 < 10;
                if (!isLt2M) {
                    return this.$message.error('上传文件大小不能超过 10MB!');
                }
                this.uping = this.$loading({
                    lock: true,
                    text: "上传中，请稍后",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.2)",
                });
            },
            //  上传成功
            uploadSuccess(res,file) {
                this.uping.close();
                if (res.code === 200) {
                    if (this.multiple) {
                        this.files.push({
                            name:file.name,
                            url:res.url
                        })
                    }else {
                        this.files = {
                            name:file.name,
                            url:res.url
                        }
                    }
                    this.$emit('uploadFile',{
                        type:this.type,
                        files: this.files
                    })
                }else {
                    toast(res.msg,TOAST.error)
                }
            },
            //  上传失败
            uploadError() {
                this.uping.close();
                this.$message({
                    message: "上传出错，请重试！",
                    type: "error",
                    center: true,
                });
            },
            delItem(index){
                confirm(`删除`, `你确定删除该附件吗？`, () => {
                    this.files.splice(index,1)
                    this.$emit('uploadFile',{
                        type:this.type,
                        files: this.files
                    })
                }, '确认', true)
            }
        },
        watch: {
            file() {
                this.fileList = this.file
            }
        }
    }
</script>

<style scoped lang="scss">
    .up-box {
        .file{
            margin-bottom: 5px;
            border-bottom: 1px solid #eeeeee;
        }
    }
</style>